export const styledTheme = {
  lightblue: '#00AFEF',
  blue: '#278ADA',
  darkblue: '#0E2C44',
  midblue: '#1B4160',
  navyblue: '#071827',
  lightbluegrey: '#B4C2CE',
  bluegrey: '#7194AC',
  darkgrey: '#8FA9BE',
  meddarkgrey: '#C1CDD7',
  mediumgrey: '#CED8E3',
  medlightgrey: '#E0E5E9',
  lightgrey: '#E5E8E9',
  gray: '#EDF0F3',
  white: '#FFFFFF',
  red: '#CA3A3A',
  lightestCobalt: '#254a66',
  pink: '#D3347F',
  orange: '#FF886D',
  purple: '#966CB8',
  green: '#54C06E',
  cobalt: '#466B88',
  black: '#000000',
  lightGray: '#B4C2CE',
  darkGray: '#0E2C44',
  darkBlue: '#0e2b44',
  darkgreyHover: '#A6C0D4',
  darkblueHover: '#153A57',
  lightCobalt: '#5C80A2',
  navyblueHover: '#052135',
  navySecondary: '#1E3E58',
  orangeHover: '#FF9F89',
  purpleHover: '#7C688C',
  greenHover: '#6AE187',
  cobaltHover: '#5A82A2',
  focusPlaceholder: '#AAAAAA',
  cobalt400: '#8FA9BE',
};
